import classNames from "classnames"
import React, { useCallback, useState } from "react"

import type { InteractiveMapProps } from "@/components/LuggageStorage/Map/Interactive/InteractiveMap"
import { InteractiveMap } from "@/components/LuggageStorage/Map/Interactive/InteractiveMap"
import type { StaticMapProps } from "@/components/LuggageStorage/Map/Static/StaticMap"
import { StaticMap } from "@/components/LuggageStorage/Map/Static/StaticMap"

type HeroMapProps = InteractiveMapProps &
  StaticMapProps & {
    visible: boolean
  }

export const HeroMap = ({ coordinates, nearestStores, searchUrl, query, getStoreUrl, visible }: HeroMapProps) => {
  const [isInteractiveMapLoaded, setIsInteractiveMapLoaded] = useState(false)

  const handleMapLoaded = useCallback(() => {
    setIsInteractiveMapLoaded(true)
  }, [])

  return (
    <div className={classNames("mb-4 grid w-full grid-cols-1 grid-rows-1", visible ? "block" : "block md:hidden")}>
      <div
        className={classNames(
          "col-start-1 row-start-1 transition-opacity duration-1000 ease-in-out",
          !isInteractiveMapLoaded ? "opacity-100" : "opacity-0",
        )}>
        <StaticMap coordinates={coordinates} nearestStores={nearestStores} searchUrl={searchUrl} query={query} />
      </div>
      <div
        className={classNames(
          "col-start-1 row-start-1 transition-opacity duration-1000 ease-in-out",
          isInteractiveMapLoaded ? "opacity-100" : "opacity-0",
        )}>
        <InteractiveMap
          coordinates={coordinates}
          nearestStores={nearestStores}
          getStoreUrl={getStoreUrl}
          onMapLoaded={handleMapLoaded}
        />
      </div>
    </div>
  )
}
